import Column from '@app/components/layout/Column'
import { ArticleSection } from '@app/components/blocks/ArticleSection'
import { GeoViewModel } from './models'

export const Current = ({ region }: { region: GeoViewModel }) => {
  return (
    <Column alignItems="stretch" gap="2rem">
      {/* <section>
        <SectionHeader title={translations.events} />
        <Event
          date={14}
          month="Oktober"
          category="INFORMATIE"
          title="Informatiebijeenkomst over CPO-bouwen in Mill"
          description="Informatiebijeenkomst over CPO-bouwen in Mill"
          time="10:00 - 12:00"
          location="Amsterdam"
        />
      </section> */}
      <ArticleSection
        stories={region.stories ?? []}
        news={region.news ?? []}
        blogs={region.blogs ?? []}
      />
    </Column>
  )
}
